module.exports = __webpack_public_path__ + "img/wanfang.892a6854.jpg";